import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDeviceRegitration } from '../../../../../../actions/SelectDevice';
import DisplayWebEligibleDevice from '../../../../../../components/Web/Customer/DisplayWebEligibleDevice/DisplayWebEligibleDevice';
import { BMC_ENROLMENT_TYPE, ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS, refreshBtn } from '../../../../../../constants/AppConstants';
import { pushDataLayer, updateDeviceInfoToLocalStorage } from '../../../../../../constants/AppMethod';
import { routePath } from '../../../../../../constants/Routes';
import deviceOffline from '../../../../../../assets/images/printer-offline.svg';
import ErrorPage from '../../../../../../components/shared/errorPage/ErrorPage';
import Loader from '../../../../../../components/shared/loader/Loader';
import DisplayUpdateAccountConfirmation from '../../../../../../components/EditMyAccount/DisplayUpdateAccountConfirmation/DisplayUpdateAccountConfirmation';
import { getLocalSessionData, getUserSessionData } from '../../../../../../utils/Authentication/handleUserSession';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import UseCheckNetworkStatus from '../../../../../../utils/CustomHooks/UseCheckNetworkStatus';
import { useAppNavigation } from '../../../../../../utils/CustomHooks/useAppNavigation';

const WebAddEligibleDevice = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation(["translation"]);
    const history = useHistory();
    const { subscriptionKind } = props?.location?.state || {};
    const {
        offlineStatus,
        oneTimeRecheck,
        onConfirmDeviceClick,
        callBMCRedirection,
        setOfflineStatus,
        setOneTimeRecheck,
        setConfirmDeviceClick,
        setBMCRedirection,
        recheckNetworkStatus
    } = UseCheckNetworkStatus();

    const { goToWebPlaceOrder } = useAppNavigation();

    const [selectedEligibleDeviceId, setSelectedEligibleDeviceId] = useState("")
    const [selectedEligibleDevice,setSelectedEligibleDevice] = useState("")
    const [selectedDeviceNetworkStatus, setSelectedDeviceNetworkStatus] = useState("")
    const deviceCapabilityResult = useSelector((state) => state.DeviceCapability)
    const deviceListRecheckResult = useSelector((state) => state.SelectDevice);

    const { unEnrolledDevicesList } = deviceListRecheckResult || {} // supports multiple devices enrollment
    const deviceRegistrationResult = useSelector((state) => state.DeviceRegistration)
    let networkStatus; 

    const onDeviceSelection = (newDevice,type) => {
      const deviceKeysToSessionMap = {
        deviceId: LOCALSESSIONDATAKEYS.DEVICE_ID,
        model: LOCALSESSIONDATAKEYS.DEVICE_MODEL,
        serialNumber: LOCALSESSIONDATAKEYS.SERIAL_NUMBER,
        printerType: LOCALSESSIONDATAKEYS.PRINTER_TYPE,
      };
      updateDeviceInfoToLocalStorage(newDevice, deviceKeysToSessionMap)
      setSelectedEligibleDeviceId(newDevice.deviceId)
      setSelectedDeviceNetworkStatus(newDevice.networkStatus)
      networkStatus = newDevice.networkStatus
      setSelectedEligibleDevice(newDevice)
      setOneTimeRecheck(false)
    }
    const onConfirmEligibleDeviceSelection = () => {
      const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
      const deviceId = selectedEligibleDeviceId;
      if(networkStatus === "online" || selectedDeviceNetworkStatus === "online"){
        dispatch(getDeviceRegitration(UID, deviceId))
      }
      else if(networkStatus === "offline" || selectedDeviceNetworkStatus === "offline"){
        setOfflineStatus(true)
      }
      pushDataLayer('add_device',"device_id",deviceId)
      setConfirmDeviceClick(true)
    }

    useEffect(()=>{
      if(deviceRegistrationResult.success && onConfirmDeviceClick){
        goToWebPlaceOrder({subscriptionKind});
        setConfirmDeviceClick(false)
      }
       // eslint-disable-next-line
    },[deviceRegistrationResult.success, history, onConfirmDeviceClick])

    if (unEnrolledDevicesList?.length > 0){
        unEnrolledDevicesList.map((device) =>{
          let selectedDeviceId;
          if(selectedEligibleDeviceId){
            selectedDeviceId = selectedEligibleDeviceId
          }
          else{
            selectedDeviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
          }
          if(device.deviceId === selectedDeviceId){
            networkStatus = device.networkStatus
            if(device.networkStatus === "online" && oneTimeRecheck){
              const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
              dispatch(getDeviceRegitration(UID, device.deviceId))
              setOneTimeRecheck(false);
              setBMCRedirection(false);
            }
          }
          return device;
        })
    }
    
    if(deviceRegistrationResult.error){
      return (
        <ErrorPage
          errorInfo={deviceRegistrationResult.error}
          showRefreshBtn={refreshBtn.HIDE}
          ></ErrorPage>
      )
    }
    if (unEnrolledDevicesList?.length === 0) {
      return (
        <ErrorPage
          errorInfo={t("ERROR_CONTENT.NO_DEVICES")}
          showRefreshBtn={refreshBtn.HIDE}
        ></ErrorPage>
      );
    }

    if(deviceCapabilityResult.loading || deviceRegistrationResult.loading) {
      return <Loader></Loader>
    }

    let selectedDeviceForPlans = {'deviceId':selectedEligibleDeviceId,'device_model': selectedEligibleDevice.model,'serialNumber':selectedEligibleDevice.serialNumber,'networkStatus':selectedEligibleDevice.networkStatus}
      /**
       * If device status is offline, the offline content will be displayed
       * On retry the updated device info should be fetched, so this component is called to evaluate the latest       device info.
       */
    if(callBMCRedirection){
      return <Redirect to= {{pathname: routePath.PROCESS_DEVICE, state: {
        source: BMC_ENROLMENT_TYPE.BMC_AS_POST_ENROLLMENT_SERVICE,
        subscriptionKind: subscriptionKind
      }}}/>
    }
    if(offlineStatus){
      return <DisplayUpdateAccountConfirmation
        updateAddressHeader={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_HEADER")}
        updateAddressInfo={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_INFO")}
        updateAddressBtn={t("ECOPRO_BTNS.RETRY")}
        onUpdateClick = {()=>recheckNetworkStatus()}
        image={deviceOffline}
        ></DisplayUpdateAccountConfirmation>
    }

    return (
      <>
        { 
          (callBMCRedirection)
          ? <Loader />
          : <DisplayWebEligibleDevice 
              header={t("CUSTOMER_WEB.ADD_MY_DEVICE.CONNECT_YOUR_DEVICE")}
              subheader={t("CUSTOMER_WEB.ADD_MY_DEVICE.CONNECT_DEVICE_INFO")}
              selectInfo={t("CUSTOMER_WEB.ADD_MY_DEVICE.YOUR_ELIGIBLE_DEVICES")}
              eligibleDevices={unEnrolledDevicesList} 
              selectedreplacementDeviceId={selectedEligibleDeviceId}
              onRelacementSelection={onDeviceSelection}
              onConfirmEligibleDeviceSelection={onConfirmEligibleDeviceSelection}
              btnText = {t('ECOPRO_BTNS.CONTINUE')}
              linkUrl = {routePath.PLANS}
              linkWithState = {selectedDeviceForPlans}
              linkText ={t("CUSTOMER_WEB.ADD_MY_DEVICE.CHANGE_SUBSCRIPTION")}
              selectedModel = {selectedEligibleDevice.model}
            ></DisplayWebEligibleDevice>
        }
      </>
    );
};

export default WebAddEligibleDevice;